import * as React from "react";
import { AppContext } from "./app-context-provider";
export const useMaybeApp = () => {
    const { app } = React.useContext(AppContext);
    return app;
};
export const useApp = () => {
    const app = useMaybeApp();
    if (!app) {
        throw new Error("App not found");
    }
    return app;
};
